import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function BtmcFound() {
  const dateTexts = ['1850年'];
  const title = 'ビッグサンダー・マイニングカンパニー設立';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2017/09/barnabas-t-bullion.jpg'
  const description = (
    <>
      {'S.E.A.メンバーの一人'}
      <a href='/barnabas-t-bullion'>
        {'バーナバスT.ブリオン'}
      </a>
      {'が、ビッグサンダーマウンテンで金を採掘するために、ビッグサンダー・マイニングカンパニーを設立する。'}
      {'設立にあたってハイタワー・インダストリーズからの融資を受ける。'}
    </>
  );
  const quoteDomain = 'disney.wikia.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
      objectPosition='30%'
    />
  );
}

export default BtmcFound;
